import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { ChevronRight, Newspaper } from "lucide-react";
import { stripHtml } from "@/components/app/RichTextView";

export default function News() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data || []));
  }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8">
        <div className="text-xs font-mono uppercase tracking-widest text-[#c85a32]">Updates</div>
        <h1 className="mt-1 font-serif text-4xl font-semibold text-stone-900 sm:text-5xl">Latest News</h1>
        <p className="mt-2 text-stone-600">Announcements and community updates for Salford Town Hall.</p>
      </header>

      {items.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-stone-300 bg-white p-10 text-center text-stone-600">
          <Newspaper className="mx-auto mb-3 h-8 w-8 text-stone-400" />
          No news articles yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {items.map((n, i) => (
            <Link
              key={n.id}
              to={`/news/${n.id}`}
              data-testid={`news-article-card-${i}`}
              className="group overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm transition hover:shadow-lg"
            >
              {(() => {
                const firstImg = (n.attachments || []).find((a) =>
                  (a.content_type || "").startsWith("image/"),
                );
                return firstImg ? (
                  <img src={fileUrl(firstImg.file_id)} alt="" className="h-44 w-full object-cover" />
                ) : null;
              })()}
              <div className="p-6">
                <div className="text-xs font-mono uppercase tracking-widest text-[#c85a32]">
                  {n.date ? new Date(n.date).toLocaleDateString("en-GB") : ""}
                </div>
                <h3 className="mt-2 font-serif text-2xl font-semibold text-stone-900 group-hover:text-[#c85a32]">
                  {n.headline}
                </h3>
                <p className="mt-2 text-stone-700">
                  {stripHtml(n.body).slice(0, 200)}
                  {stripHtml(n.body).length > 200 ? "…" : ""}
                </p>
                <div className="mt-4 inline-flex items-center text-sm font-medium text-[#c85a32]">
                  Read full article <ChevronRight className="ml-1 h-4 w-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
